angular
    .module('app')
    .factory('NewTracesExService', function (moment) {
    // Trace summary cache
    let isNewTraces = false;
    let traceCache = [];
    // Trace Details cache
    let detailsCache = [];
    let isNewDetails = false;
    let fac = {
        // TraceSummary
        isNewTraces: isNewTraces,
        addToCache: addToCache,
        fetchFromCache: fetchFromCache,
        // TestDetails
        isNewDetails: isNewDetails,
        addToDetailsCache: addToDetailsCache,
        fetchFromDetailsCache: fetchFromDetailsCache,
        // Utilities
        adjustToLocalTime: adjustToLocalTime,
        removeDuplicateTvNodes: removeDuplicateTvNodes,
        removeDuplicateAttachments: removeDuplicateAttachments,
        filterRows: filterRows
    };
    // Trace Summary traces cache
    function addToCache(nodes) {
        let traceTemp = traceCache.concat(nodes);
        traceCache = traceTemp;
        fac.isNewTraces = true;
    }
    function fetchFromCache() {
        // let traceTemp = traceCache;
        let traceTemp = angular.copy(traceCache);
        traceCache = [];
        fac.isNewTraces = false;
        return traceTemp;
    }
    function addToDetailsCache(nodes) {
        let detailsTemp = detailsCache.concat(nodes);
        fac.isNewDetails = true;
        detailsCache = detailsTemp;
    }
    function fetchFromDetailsCache() {
        // let detailsTemp = detailsCache;
        let detailsTemp = angular.copy(detailsCache);
        detailsCache = [];
        fac.isNewDetails = false;
        return detailsTemp;
    }
    // TODO: This use to be a value. Now it is a function
    // function isNewDetails() { return detailsCache.length > 0; }
    // Utility methods
    function adjustToLocalTime(nodes, timezoneOffset) {
        // Only if we have to
        if (timezoneOffset === 0) {
            return nodes;
        }
        // NOTE: Convert UTC time to local time and patch the node label
        angular.forEach(nodes, function (node) {
            try {
                let ts = moment(node.MessageTimestamp).subtract(timezoneOffset, 'm');
                let tsFormatted = ts.format('HH:mm:ss DDMMMYY');
                let label = tsFormatted +
                    ' ' +
                    _.drop(node.Rows[0].label.split(' '), 2)
                        .join(' ')
                        .replace(/\s+/g, ' ');
                node.Rows[0].label = label;
            }
            catch (ex) {
                // If we fail to format the timestamp then indicate with a *
                node.Rows[0].label = '* ' + node.Rows[0].label;
            }
        });
        return nodes;
    }
    function removeDuplicateTvNodes(newNodes, existingNodes) {
        let existingRowIds = _.map(existingNodes, 'traceId');
        let nonDuplicateNewRows = _.reject(newNodes, function (newRow) {
            return _.includes(existingRowIds, newRow.traceId);
        });
        return nonDuplicateNewRows;
    }
    function removeDuplicateAttachments(newRows, existingRows) {
        let existingRowIds = _.map(existingRows, 'Id');
        let nonDuplicateNewRows = _.reject(newRows, function (newRow) {
            return _.includes(existingRowIds, newRow.Id);
        });
        return nonDuplicateNewRows;
    }
    function filterRows(nodes, traceSummaryRequest) {
        let tsr = traceSummaryRequest;
        // If we are in TraceDetails the filter by the req UserId, SimId, TestSuiteId, TestId
        // against the node.Row[0] UserId, SimId, SuiteId, TestId
        let isDetails = tsr.UserId > -1 &&
            tsr.SimId > -1 &&
            tsr.TestSuiteId > -1 &&
            tsr.TestId > -1;
        if (isDetails) {
            let traceDetailNodes = _.filter(nodes, function (node) {
                let obj = node.Rows[0];
                return (obj.UserId === tsr.UserId &&
                    obj.SimId === tsr.SimId &&
                    obj.SuiteId === tsr.TestSuiteId &&
                    obj.TestId === tsr.TestId);
            });
            return traceDetailNodes;
        }
        // Otherwise we filter by all of the the search criteria
        if (tsr.UserId > -1) {
            nodes = _.filter(nodes, function (node) {
                return node.Rows[0].UserId === tsr.UserId;
            });
        }
        if (tsr.SimId > -1) {
            nodes = _.filter(nodes, function (node) {
                return node.Rows[0].SimId === tsr.SimId;
            });
        }
        if (tsr.TestSuiteId > -1) {
            nodes = _.filter(nodes, function (node) {
                return node.Rows[0].SuiteId === tsr.TestSuiteId;
            });
        }
        // TODO: Confirm that this is correct
        // NOTE: Previously we were using node.Rows.VerdictResult
        if (tsr.failedVerdictsOnly) {
            nodes = _.filter(nodes, function (node) {
                return (node.VerdictResult === 'verdict-failed' ||
                    node.VerdictResult === 'verdict-failed-reasons');
            });
        }
        // The date search is for a full day
        if (tsr.selectedDate) {
            nodes = _.filter(nodes, function (node) {
                let dtFormat = 'YYYYMMDD';
                let ts = moment(node.MessageTimestamp).format(dtFormat);
                let dt = moment(tsr.selectedDate).format(dtFormat);
                return ts === dt;
            });
        }
        return nodes;
    }
    return fac;
});
